var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128060(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2021_OP_symbolikuvitus_128_060",
    clipPath: "url(#clip0_8796_5230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M128 0H0V128H128V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M105.45 88.8101C105.45 88.8101 88.6002 97.1401 85.9102 78.3601C83.9102 64.3601 90.1902 62.1901 84.9102 53.3601C97.5702 55.8601 103.77 62.0901 100.14 76.1901C96.2202 91.5201 105.45 88.8101 105.45 88.8101Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.55 82.6201L43.43 88.2901C37.82 90.7101 34.28 95.7101 34.28 101.19V108.19",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.55 82.6201L43.43 88.2901C37.82 90.7101 34.28 95.7101 34.28 101.19V108.19",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1401 82.6201L83.2701 88.2901C88.8701 90.7101 92.4201 95.7101 92.4201 101.19V108.19",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1401 82.6201L83.2701 88.2901C88.8701 90.7101 92.4201 95.7101 92.4201 101.19V108.19",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M56.77 76.1702V83.2602C56.77 87.6402 60.23 89.5902 63.35 89.5902C66.47 89.5902 69.92 87.5902 69.92 83.2602V76.1702H56.77Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.17 56.7301C42.8615 54.3401 42.2158 51.6436 42.3 48.9201C42.3 33.3201 48.75 22.6201 64.1 22.6201C79.45 22.6201 85.91 33.3201 85.91 48.9201C86.0495 52.1973 85.069 55.4244 83.13 58.0701",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 62.7601C84.6 63.1301 85.44 61.0701 86.19 58.5601C87.11 55.4901 85.96 53.7201 83.36 53.3401",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 62.7601C84.6 63.1301 85.44 61.0701 86.19 58.5601C87.11 55.4901 85.96 53.7201 83.36 53.3401",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.35 62.7601C42.75 63.1301 41.91 61.0701 41.16 58.5601C40.24 55.4901 41.39 53.7201 43.99 53.3401",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.35 62.7601C42.75 63.1301 41.91 61.0701 41.16 58.5601C40.24 55.4901 41.39 53.7201 43.99 53.3401",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M83.26 52.41L81 45.25H67.69L67 41.34L65.65 45.25H62.55L61.35 40.78L60.28 45.25H56L54.35 37.8L52.63 45.25H46.4C46.4 45.25 44.15 52.9201 44.18 53.3301C44.69 63.0201 46.63 67.7101 49.73 71.6501C53.4 76.3001 59.44 79.8001 63.65 79.8001C67.86 79.8001 74.53 76.3101 77.81 71.6501C81.09 66.9901 82.81 62.14 83.26 52.41Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M63.46 56.3401L62.58 62.1401C62.5397 62.4051 62.5571 62.6756 62.631 62.9333C62.705 63.1909 62.8337 63.4295 63.0085 63.6327C63.1832 63.836 63.3998 63.999 63.6435 64.1108C63.8871 64.2225 64.152 64.2803 64.42 64.2801H65.66",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M74.22 48.25L78.44 48.95",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M54.0601 48.25L49.8401 48.95",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M66.4101 68.3201C66.2593 68.8139 65.954 69.2462 65.539 69.5534C65.124 69.8606 64.6214 70.0265 64.1051 70.0265C63.5887 70.0265 63.0861 69.8606 62.6711 69.5534C62.2561 69.2462 61.9508 68.8139 61.8 68.3201",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M53.3499 58.86C54.5539 58.86 55.5299 57.884 55.5299 56.68C55.5299 55.476 54.5539 54.5 53.3499 54.5C52.1459 54.5 51.1699 55.476 51.1699 56.68C51.1699 57.884 52.1459 58.86 53.3499 58.86Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M74.0901 58.8402C75.2941 58.8402 76.2701 57.8642 76.2701 56.6602C76.2701 55.4562 75.2941 54.4802 74.0901 54.4802C72.8862 54.4802 71.9102 55.4562 71.9102 56.6602C71.9102 57.8642 72.8862 58.8402 74.0901 58.8402Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8796_5230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128060);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_060.4f8382a207d99c8cfb4c02328daf5cd8.svg";
export { ForwardRef as ReactComponent };